import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from '@/store/modules/auth'
import ors from '@/store/modules/ors'
import patient from '@/store/modules/patient'
import nav from '@/store/modules/nav'
import snackbar from '@/store/modules/snackbar'
import RecordList from '@/store/modules/RecordList'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    ors,
    patient,
    nav,
    snackbar,
    RecordList
  },
  plugins: [createPersistedState()],
  strict: true
})



// WEBPACK FOOTER //
// ./src/store/index.js